import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { List } from 'immutable';
import { Observable } from 'rxjs';
import { v4 } from 'uuid';
import { onActions } from '../../utils/helpers/redux.helper';
import { Document } from '../document-data/document.model';
import { IRendererOptions } from '../renderer/renderer.interface';
import {
  ActionsEnum,
  fetchPayPalTransactionHistory,
  getTransactionHistoryUrl,
  sendInvoiceUnopenedPreview,
  sendReceipt,
  sendReceiptPreview,
  sendRemindersPreview,
  triggerPayPalOnboardingCanvas,
} from './payments-data.actions';
import { IAddPaymentPayload } from './payments-data.data';

@Injectable()
export class PaymentsDataDispatcher {
  constructor(private _store: Store<any>, private _actions: Actions) {}

  sendRemindersPreview(reminderDays: List<number>) {
    this._store.dispatch(sendRemindersPreview(reminderDays));
  }

  sendInvoiceUnopenedPreview() {
    this._store.dispatch(sendInvoiceUnopenedPreview());
  }

  sendReceipt(
    documentId: string,
    recipient: string,
    transactionId: string,
    rendererOptions: IRendererOptions,
    updatePaymentReceiptsSettings: boolean
  ): Observable<any> {
    const dispatchId = v4();

    this._store.dispatch(
      sendReceipt(
        dispatchId,
        documentId,
        recipient,
        transactionId,
        rendererOptions,
        updatePaymentReceiptsSettings
      )
    );

    return onActions(
      this._actions,
      [ActionsEnum.SEND_RECEIPT_SUCCESS, ActionsEnum.SEND_RECEIPT_ERROR],
      dispatchId
    );
  }

  sendReceiptPreview(
    document: Document,
    transaction: IAddPaymentPayload,
    rendererOptions: IRendererOptions
  ): Observable<any> {
    const dispatchId = v4();

    this._store.dispatch(
      sendReceiptPreview(dispatchId, document, transaction, rendererOptions)
    );

    return onActions(
      this._actions,
      [
        ActionsEnum.SEND_RECEIPT_PREVIEW_SUCCESS,
        ActionsEnum.SEND_RECEIPT_PREVIEW_ERROR,
      ],
      dispatchId
    );
  }

  getTransactionHistoryUrl(
    documentId: string,
    transactionId: string
  ): Observable<any> {
    const dispatchId = v4();

    this._store.dispatch(
      getTransactionHistoryUrl(dispatchId, documentId, transactionId)
    );

    return onActions(
      this._actions,
      [
        ActionsEnum.GET_TRANSACTION_HISTORY_URL_SUCCESS,
        ActionsEnum.GET_TRANSACTION_HISTORY_URL_ERROR,
      ],
      dispatchId
    );
  }

  triggerPayPalOnboardingCanvas(returnUrl?: string) {
    this._store.dispatch(triggerPayPalOnboardingCanvas(returnUrl));
  }

  fetchPayPalTransactionHistory(timestamp?: string) {
    this._store.dispatch(fetchPayPalTransactionHistory(timestamp));
  }
}
